const backdoorRouteArr = [
  {
    path: '/backdoor/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        redirect: { name: 'backdoorMockBaNotification' }
      },
      {
        path: 'mockBaNotification',
        name: 'backdoorMockBaNotification',
        component: () => import('@/views/Backdoor/BackdoorView.vue'),
        meta: {
          prev: 'goHome'
        }
      }
    ]
  }
]

export default process.env.VUE_APP_ENV === 'prod' ? [] : backdoorRouteArr
